/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * TimePickerWithClocks styles
 *
 * @author Nikolay Sviridov
 * @version 1.35.0
 * @since 1.35.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export const TimePickerWithClocksDropdownStyled = styled.div.attrs(() => ({
    className: 'date-picker-dropdown',
}))`
    width: 295px;
    .drop-down-filter .drop-down-filter__select-placeholder {
        opacity: 1;
    }

    .drop-down-filter__tooltip {
        padding: 24px;
    }

    .drop-down-filter__filter-button {
        height: 48px;

        & input, & .input__container {
            height: 100%;
        }

        & ::placeholder {
            color: ${colors.textColor};
        }
    }
`;

export const TimePickerWithClocksStyled = styled.div.attrs({
    className: 'date-picker',
})`
`;

export const TimePickerWithClocksCellWrapperStyled = styled.div.attrs({
    className: 'date-picker__cell-wrapper',
})`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    column-gap: 10px;
`;

export const TimePickerWithClocksCellStyled = styled.div.attrs((props: IAttrStyled) => ({
    className: `date-picker__cell ${props.className || ''}`,
}))<IAttrStyled>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;

    ${fonts.textSmall};
`;
